var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_43247",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_43247)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -2,
    width: 25,
    height: 22,
    fill: "#2B3558"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_39_43247",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_39_43247",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAEnQAABJ0BfDRroQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAVBSURBVHic7ZpPbBR1FMe/b6e7DYJr1QMNYkzUUBtIqAYQQi9EPVDoQU1nf5PSIigsnoh/knpAXTg1MWjCQVlQCHXZ38w0ITEIES4rCQkoKUVouKAHTUASo7CNYtntzPNAmwwzU9hdZmdV5nOb937z5vvevJnfbyY/ICIiIiIiIuJ+hWZymKaZsCcnN4DodQBPA3g4PFmBcA3AjyD6vFgs7k+n02W/Qb4FkFLOI+AwgOfqqTA0iEbK5XJ3X1/frx6X23D06NHm8WLxOwCLQxEXHqMxRVmuqmrJaYy5RxWLxTfw/0seAJ5ly9roNjb5DOz3WIiuM/M6TdOO1ENZ0Oi6vhbAl2BucdoZWA9gt9PmKQABCz0RmVsI+FqXcjimKFtUVf0jYM2BYJrmI7Zl7QZzj+8AZk9unkcAwOw7XKPHtqzvDcNYWaPGumEYxkrbss4A8E8eAIgedJv8HgE3ZQBxx/FTbNsn9Hz+o1hT04ful0rYmKaZYMvawbb9LgDF5XZr9+DXAbcPUJQOAGddZgVE79mWdU5KuaQqxQEipVxiW9Y5BgbgTf7slPY7ctcCqKp6sTg+vpyB7QAsl7udgFOGlIPZbPaOlQ6SbDYbN6QcJOAUgHaX22Jg+9zW1udVVb14t1h3LQAApNPpsqZpGRB1ArjkcjcxMJBMJk+aptlWWQq1Y5pmWzKZPDl1192P8CUQdWqallm1atVkJfEqKsA0QojTs+fM6SBgFwB2+ghYZlvWqJRyIJPJVBW3EjKZTExKOWBb1igBy1xuJmBXTFEWCyFOVxO3aqHd3d03Upq2lWx7NYArLvcsAgbb29q+yeVy86uNPRO5XG7+MwsWHCNgEMAsl/sK2fbqlKZtVVX172pj13ynUr29x6ZeMofcPgZealKUMSllX63xp5FS9jUpyhiIXvRx55snJhamenuP1Rq/kmlwRlRV/Q3Aq7qu94A5i9u/GB8iYEiXsjtRKr35yvr1v1cT+9CBA4+WEonP4D+vXwNRWggxfA/yAdxDBzgRQgzHFKUDzAUfd08pkRiTUq6pNJ6u62tLicQY/JJnLsQUpSOI5IF77AAnqqr+wswvGIaxCcyfAHjA4W4l4LAu5d5Sufx2f3//X34xhoaGZifi8Y/BvAneL9UbIHorJcReImK/82sh0Lc1EbEQYk9MUZaCaMTtBrA5EY+fN/P5Tve5Zj7fmYjHzwPYDHfyRCMgWiKE2BNk8kCAHeBEVdWLhUJh+dWrV7cRsA23r9KetIkKhpQ7SVE+AAC2rB028I6PnjID77fOnbuz0nm9WupSAACYEpwxDOME2/Z+AE84r8vAAFvWdCf4fVz9zMBrmqZ9Wy+NQMCPgB+pVKoQU5R2v8UTbiXuTn56UdNe7+SBOnaAk6kFylZd14+AeR+Ax2YYehlEG1NCHA9DFxBCBzgRQhxvnphYBOaDHifzweaJiUUixOSBkDrAycsbNlwHsE7X9a/AfOv3FNEWoWmBzOvVEmoHOBFCDINomWXbS4Na1NRC6B3gRAjxUyOvDzSwA/4tRAVotIBGExWg0QIaTVSARgtoNFEBGi2g0UQFaLSARhMVwMf2p/PANM2Zfl7865FSPu4yjbvHeArAwAXnsW1Zu6WU8wLWVnemdrp96jJfcI/zbpFhzoFohcO0loDLupRBawwdAnJum6cDki0tXwD4IRRF4TJKirLPbfQUoKur6yYDXfDuCvnvQjRSnpxc47edx3cW0DTtSkxRVoB5C4AzAG7WW2MduAngDIjSxWJxhd8u0YiIiIiIiIiIiIiI+5d/AFp5udiYzSmxAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.f85e1d4def940ef044f844a2dc5cc0ff.svg";
export { ForwardRef as ReactComponent };